import { render, staticRenderFns } from "./PcBanner.vue?vue&type=template&id=0423ee79&scoped=true&"
import script from "./PcBanner.vue?vue&type=script&lang=js&"
export * from "./PcBanner.vue?vue&type=script&lang=js&"
import style0 from "./PcBanner.vue?vue&type=style&index=0&id=0423ee79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0423ee79",
  null
  
)

export default component.exports